<template>
  <el-select
    :class="{ 'not-set': focused && isRequired }"
    :clearable="clearable"
    :default-first-option="true"
    :filter-method="handleFilterSubscribersChange"
    :loading="loading"
    :placeholder="placeholder"
    :value="value"
    collapse-tags
    filterable
    no-data-text="No hay abonados"
    popper-class="select-subscribers"
    size="mini"
    style="width: 100%"
    v-bind="$attrs"
    v-on="$listeners"
    @visible-change="handleVisibleChange"
  >
    <el-option
      v-for="item in filteredSubscribers"
      :key="item.value"
      :disabled="isDisabled"
      :label="item.label"
      :value="item.value"
    >
      <span class="label-left" v-html="highlight(item.label)"></span>
      <span v-show="item.ref" class="label-right mr-3" v-html="`Ref: ${highlight(item.ref)}`">
      </span>
    </el-option>
  </el-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import filterMixin from "@/mixins/filter";
import { escapeRegExp } from "@/utils/regexp";

export default {
  name: "SelectSubscribers",

  mixins: [filterMixin],

  inheritAttrs: false,

  props: {
    wgId: Number,
    value: {
      type: [Array, Number, String],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecciona abonados",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    only: {
      type: Array,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      subscribers: [],
      textFilter: "",
      focused: false,
      loading: false,
    };
  },

  watch: {
    value(newVal) {
      if (newVal && this.subscribers.length < 1) {
        this.fetchSubscribers();
      }
    },
    wgId() {
      this.fetchSubscribers();
    },
  },

  computed: {
    ...mapGetters("app", ["defaultWorkgroup"]),

    formattedSubscribers() {
      let subscribersFormatted = this.subscribers
        .filter((sub) => !sub.deleted)
        .map((subscriber) => {
          return {
            value: subscriber.id,
            label: subscriber.name,
            ref: subscriber.ref,
          };
        });
      if (this.$attrs.multiple) {
        subscribersFormatted.unshift({
          value: 0,
          label: "Todos los abonados",
        });
      }
      return subscribersFormatted;
    },

    preFilteredSubscribers() {
      const subscribers = this.formattedSubscribers;
      if (this.only) {
        return subscribers.filter((sub) => this.only.includes(sub.value));
      }
      return subscribers;
    },

    filteredSubscribers() {
      const subscribers = this.preFilteredSubscribers;
      if (!this.textFilter) {
        return subscribers;
      }
      const text = this.textFilter;
      const regexp = new RegExp(escapeRegExp(text), "i");
      return subscribers.filter(
        (sub) => sub.label.match(regexp) || (sub.ref && sub.ref.match(regexp))
      );
    },
  },

  methods: {
    ...mapActions("clientSubscribers", ["getSubscribers"]),

    handleFilterSubscribersChange(text) {
      this.textFilter = text;
    },

    async handleVisibleChange(visible) {
      if (visible && this.subscribers.length < 1) {
        await this.fetchSubscribers();
      }
      this.focused = visible;
      if (!visible && !this.value && this.isRequired && this.textFilter != "") {
        this.$message({
          type: "error",
          message: "No se ha seleccionado ningún abonado",
        });
      }
      this.textFilter = "";
    },

    async fetchSubscribers() {
      this.loading = true;
      this.subscribers = await this.getSubscribers({
        wgId: this.wgId ?? this.defaultWorkgroup.id,
      });
      this.loading = false;
    },
  },
};
</script>

<style>
.select-subscribers {
  width: 270px;
}
.label-left {
  float: left;
  line-height: 16px;
  margin: 9px 0;
  /* width: 75%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label-right {
  float: right;
  overflow: hidden;
  color: #8492a6;
  font-size: 13px;
  line-height: 16px;
  margin: 9px 0;
}
.not-set .el-input__inner {
  background: #ff000014;
}
</style>
